import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

import Imagen1 from "../../../images/modulo13/plaza.png";
import Imagen2 from "../../../images/modulo13/jrunion.png";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[11];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[10].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[10].path}`,
    titleNext: `Cierre`,
    linkNext: `${modulo13.url}/cierre`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
            <h2 className="mb-4">La ciudad como espacio de encuentro</h2>

            <p>
              Es importante que nos informemos y apoyemos iniciativas dirigidas
              a hacer de las ciudades{" "}
              <strong>espacios acogedores y respetuosos</strong> del entorno.
              Igualmente, es necesario que las autoridades hagan de la
              planificación una prioridad para el beneficio de todos.
            </p>
          </div>

          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Recordemos que las ciudades son espacios de encuentro de personas
              muy diversas que pueden dar lugar a{" "}
              <strong>nuevas y positivas relaciones</strong> entre todos.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean solamente el título del texto: La ciudad como espacio
            de encuentro. Elabore la siguiente pregunta y apunte algunas de sus
            respuestas: ¿Qué creen que significa que la ciudad sea un espacio de
            encuentro? Pida que lean en silencio el texto. Lea usted una vez más
            el texto en voz alta.
          </li>
          <li>
            Retome la pregunta planteada (¿qué creen que significa que la ciudad
            sea un espacio de encuentro?) y contraste las nuevas respuestas, a
            partir del texto leído, con lo apuntado. Debe quedar claro que la
            ciudad es un espacio para todos y todas, por tanto debería acoger a
            diversas personas. Cierre el trabajo preguntando qué podemos hacer
            para que las ciudades sean espacios respetuosos con el medio
            ambiente y espacios en los que se fomentan relaciones positivas
            entre las personas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
